require("core-js/modules/es.array.for-each.js");

require("core-js/modules/es.object.define-property.js");

;
['page', 'dom', 'merge', 'util', 'vdom', 'chartData', 'resize-event', 'rem'].forEach(function (m) {
  var moduleExports = require("./".concat(m));

  Object.assign(exports, moduleExports);
});
Object.defineProperty(exports, 'installedBrowsers', {
  enumerable: true,
  get: function get() {
    return exports.getInstalledBrowsers();
  }
});